import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { mSecondsFromEpoch } from 'src/app/types/@types/sl-v-types';
import { formatDate } from '@angular/common';



@Component({
  selector: 'app-date-of-value',
  templateUrl: './date-of-value.component.html',
  styleUrls: ['./date-of-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
}) export class DateOfValueComponent implements OnInit {
  public plusRange = true;
  public minusRange = false;
  public when: string = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  private _ready = false;
  constructor(private cdr:ChangeDetectorRef) { }

  @Input('value')
  set value(val: string) {
    this.when = val;
    this.Refresh();
  }
  get value(): string {
    return this.when;
    // return Math.floor(new Date(this.dateInput.nativeElement.value).valueOf());
  }
  @Output()
  public valueChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('dateInput') dateInput: ElementRef<HTMLInputElement>;
  public NotifyListeners() {
    this.valueChange.emit(this.value);
  }

  ngOnInit(): void {
    this._ready = true;
  }
  Refresh() {
    if(this._ready) {
      this.cdr.detectChanges();
    }
  }

}
